module.exports = __webpack_public_path__ + "img/preview.b94faadd.png";